/* tslint:disable */
/* eslint-disable */
/**
 * Mailbox API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  MailboxAddressConfigDTO,
  ProblemDetails,
} from '../models/index';
import {
    MailboxAddressConfigDTOFromJSON,
    MailboxAddressConfigDTOToJSON,
    ProblemDetailsFromJSON,
    ProblemDetailsToJSON,
} from '../models/index';

export interface MailboxAddressConfigPostRequest {
    mailboxAddressConfigDTO?: MailboxAddressConfigDTO;
}

/**
 * 
 */
export class MailboxAddressConfigApi extends runtime.BaseAPI {

    /**
     */
    async mailboxAddressConfigDeleteRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/MailboxAddressConfig`;

        const response = await this.request({
            path: urlPath,
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async mailboxAddressConfigDelete(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.mailboxAddressConfigDeleteRaw(initOverrides);
    }

    /**
     */
    async mailboxAddressConfigGetRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<MailboxAddressConfigDTO>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/MailboxAddressConfig`;

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => MailboxAddressConfigDTOFromJSON(jsonValue));
    }

    /**
     */
    async mailboxAddressConfigGet(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<MailboxAddressConfigDTO> {
        const response = await this.mailboxAddressConfigGetRaw(initOverrides);
        return await response.value();
    }

    /**
     */
    async mailboxAddressConfigPostRaw(requestParameters: MailboxAddressConfigPostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<MailboxAddressConfigDTO>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';


        let urlPath = `/MailboxAddressConfig`;

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: MailboxAddressConfigDTOToJSON(requestParameters['mailboxAddressConfigDTO']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => MailboxAddressConfigDTOFromJSON(jsonValue));
    }

    /**
     */
    async mailboxAddressConfigPost(requestParameters: MailboxAddressConfigPostRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<MailboxAddressConfigDTO> {
        const response = await this.mailboxAddressConfigPostRaw(requestParameters, initOverrides);
        return await response.value();
    }

}
